import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@raketa-cms/raketa-cms';
import { Parallax } from 'react-scroll-parallax';

import ParallaxImage from '../ParallaxImage';

const RaSectionWidget = ({ link, title, text, parallax_full_width, parallax_small_image, containerSettings }) => (
  <Container settings={containerSettings} className="parallax">
    <a href={link} className="parallax-box ra-section">
      <div className="full-width-image-mask">
        <Parallax
          offsetXMin={-100}
          offsetXMax={200}
          slowerScrollRate
          tag="figure"
        >
          <div style={{ width: '2200px', height: '900px', backgroundColor: 'rgba(0,0,0,.8)' }} />
        </Parallax>
      </div>

      <div className="full-width-image">
        <Parallax
          offsetYMin={-50}
          offsetYMax={50}
          slowerScrollRate
          tag="figure"
        >
          <ParallaxImage src={parallax_full_width} variant="parallax_full_width" />
          <ParallaxImage src={parallax_full_width} variant="parallax_full_width_mobile" />
        </Parallax>
      </div>

      <div className="small-image-mask">
        <Parallax
          offsetXMin={400}
          offsetXMax={-100}
          slowerScrollRate
          tag="figure"
        >
          <div style={{ width: '680px', height: '600px', backgroundColor: 'rgba(242,182,50,.6)' }} />
        </Parallax>
      </div>

      <div className="small-image">
        <Parallax
          offsetYMin={-50}
          offsetYMax={50}
          slowerScrollRate
          tag="figure"
        >
          <ParallaxImage src={parallax_small_image} variant="parallax_small_image" />
        </Parallax>
      </div>

      <div className="letter-bg"></div>

      <Parallax
        className="title"
        offsetYMin={-10}
        offsetYMax={1000}
        tag="div"
      >
        <h1>{title}</h1>
      </Parallax>

      <Parallax
        className="letter"
        offsetYMin={-10}
        offsetYMax={1000}
        tag="div"
      >
        <div className="letter-wrapper ra">
          <img src="data:image/svg+xml;base64,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" />
        </div>
      </Parallax>
      <div className="text" dangerouslySetInnerHTML={{ __html: text }} />
    </a>
  </Container>
);

RaSectionWidget.title = 'RA Section';
RaSectionWidget.category = 'Parallax Homepage';

RaSectionWidget.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  parallax_full_width: PropTypes.any.isRequired,
  parallax_small_image: PropTypes.any.isRequired,
  containerSettings: PropTypes.object.isRequired,
};

RaSectionWidget.defaults = {
  link: '#',
  title: 'Title',
  text: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Dicta quibusdam eius voluptate repudiandae odio aut, ea voluptas. In consectetur praesentium minus molestiae fuga hic? Tempore consequuntur debitis maiores laudantium aliquid.',
  parallax_full_width: 'http://via.placeholder.com/1680x630',
  parallax_small_image: 'http://via.placeholder.com/560x680',
  containerSettings: {},
};

RaSectionWidget.adminFields = {
  link: { type: 'text' },
  parallax_full_width: { type: 'image' },
  parallax_small_image: { type: 'image' },
  title: { type: 'text' },
  text: { type: 'rich' },
};

export default RaSectionWidget;